import { useLayoutEffect } from "react";
import { FOCUS_FILTER, FOCUS_FIRST_OPTION, FOCUS_INPUT, FOCUS_LAST_OPTION, FOCUS_NEXT_OPTION, FOCUS_PREVIOUS_OPTION, FOCUS_SELECT_ALL_BUTTON, } from "./MultiSelectFilter.types";
var GO_TO_NEXT_FOCUS_OPTION = +1;
var GO_TO_PREVIOUS_FOCUS_OPTION = -1;
var getOptionElementToMultiSelect = function (name, value) {
    if (document.querySelector('li[data-name="' + name + '"][data-value="' + value + '"]')) {
        return document.querySelector('li[data-name="' + name + '"][data-value="' + value + '"]');
    }
    return undefined;
};
var changeOptionToFocus = function (allOptions, value, modifier, name) {
    var positionOfActualOption = allOptions.findIndex(function (element) { return element.value === value; });
    return getOptionNHTMLElement(allOptions, positionOfActualOption + modifier, modifier, name);
};
var getOptionNHTMLElement = function (allOptions, nInitial, nModifier, name) {
    var nbElements = allOptions.length;
    var indexFocus = nInitial - nModifier;
    if (!allOptions[indexFocus + nModifier]) {
        return undefined;
    }
    do {
        indexFocus += nModifier;
        if (indexFocus >= nbElements) {
            indexFocus = 0;
        }
        else if (indexFocus < 0) {
            indexFocus = nbElements - 1;
        }
    } while (allOptions[indexFocus].disabled);
    return getOptionElementToMultiSelect(name, allOptions[indexFocus].value);
};
function handleNextOrPreviousOptionFocus(multiSelectModel, focusOn, name) {
    if (document.activeElement) {
        var currentValue = document.activeElement.getAttribute("data-value");
        if (currentValue) {
            var refOption = changeOptionToFocus(multiSelectModel.optionsFilteredFlat, currentValue, FOCUS_NEXT_OPTION === focusOn ? GO_TO_NEXT_FOCUS_OPTION : GO_TO_PREVIOUS_FOCUS_OPTION, name);
            refOption === null || refOption === void 0 ? void 0 : refOption.focus();
        }
    }
}
function handlePopupFocus(focusOn, refFilter, refSelectAllButton, multiSelectModel, name) {
    if (FOCUS_FILTER === focusOn && refFilter.current) {
        refFilter.current.focus();
    }
    else if (FOCUS_SELECT_ALL_BUTTON === focusOn && refSelectAllButton.current) {
        refSelectAllButton.current.focus();
    }
    else if (FOCUS_FIRST_OPTION === focusOn) {
        var refOption = getOptionNHTMLElement(multiSelectModel.optionsFilteredFlat, 0, GO_TO_NEXT_FOCUS_OPTION, name);
        refOption === null || refOption === void 0 ? void 0 : refOption.focus();
    }
    else if (FOCUS_LAST_OPTION === focusOn) {
        var refOption = getOptionNHTMLElement(multiSelectModel.optionsFilteredFlat, multiSelectModel.optionsFilteredFlat.length - 1, GO_TO_PREVIOUS_FOCUS_OPTION, name);
        refOption === null || refOption === void 0 ? void 0 : refOption.focus();
    }
    else if ([FOCUS_NEXT_OPTION, FOCUS_PREVIOUS_OPTION].includes(focusOn)) {
        handleNextOrPreviousOptionFocus(multiSelectModel, focusOn, name);
    }
}
function handleFocus(focusOn, refInput, isPopupOpen, refFilter, refSelectAllButton, multiSelectModel, name) {
    if (FOCUS_INPUT === focusOn && refInput.current) {
        refInput.current.focus();
    }
    else if (isPopupOpen) {
        handlePopupFocus(focusOn, refFilter, refSelectAllButton, multiSelectModel, name);
    }
}
export function useFocusEffect(refInput, refFilter, refSelectAllButton, multiSelectModel, isPopupOpen, focusOn, setFocusOn, name) {
    useLayoutEffect(function () {
        if (focusOn) {
            handleFocus(focusOn, refInput, isPopupOpen, refFilter, refSelectAllButton, multiSelectModel, name);
        }
        setFocusOn(undefined);
    }, [focusOn]);
}
